"use client";

import { useAuth } from "@clerk/nextjs";
import { useMemo } from "react";

import { CLERK_TOKEN_TEMPLATE } from "./clerkTokenTemplate";
import { createApiClient } from "./http";

export function useAuthedApi() {
  const { getToken } = useAuth();

  return useMemo(
    () =>
      createApiClient({
        getToken: () => getToken({ skipCache: true, template: CLERK_TOKEN_TEMPLATE }),
      }),
    [getToken]
  );
}

export function usePublicApi() {
  return useMemo(() => createApiClient(), []);
}
